import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { api, get } from "../../../../utils/api";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import WasteGeneratedView from "../../WasteGeneratedView";

const WasteGeneratedDocuments = () => {
  const { user } = useUser();
  const approvalUrl = "/scope3/wasteGeneratedInOperations/apporveOrReject";
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = user?.companyAdmin
    ? "11% 13% 12.5% 12% 13% 12.5% 13% 8%"
    : "12% 15% 13% 16% 16% 16% 8%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    wasteType: "",
    wasteManagementMethod: "",
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
      }).toString();

      const response = await get(
        `/scope3/wasteGeneratedInOperations/apporevelist?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const fetchFilter = async () => {
    try {
      const response = await get(`/scope3/wasteGeneratedInOperations/filter`);
      setFilter({
        wasteType: response.data?.data?.wasteType,
        wasteManagementMethod: response.data?.data?.wasteManagementMethod,
      });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchFilter();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Waste Management Month",
    },
    {
      title: "Waste Type",
      key: "wasteType",
    },
    {
      title: "Qty. of Waste Generated",
      key: "quantityOfWasteGenerated",
    },
    // {
    //   title: "Waste Management Method",
    //   key: "wasteManagementMethod",
    // },
    // {
    //   title: "Qty. of Waste Managed",
    //   key: "quantityOfWasteManaged",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const viewheaders = [
    {
      key: "consumptionPeriod",
      title: "Consumption Period",
      render: (data) =>
        data?.consumptionPeriod?.month && data?.consumptionPeriod?.year
          ? `${data.consumptionPeriod.month}/${data.consumptionPeriod.year}`
          : "-",
    },
    { key: "wasteCategory", title: "Waste Category" },
    { key: "wasteType", title: "Waste Type" },
    {
      key: "quantityOfWasteGenerated",
      title: "Quantity of Waste Generated",
      render: (data) =>
        data?.quantityOfWasteGenerated?.value
          ? `${data.quantityOfWasteGenerated.value} ${
              data.quantityOfWasteGenerated.unit || ""
            }`
          : "-",
    },
    {
      key: "wasteManagementMethod",
      title: "Waste Management Method",
    },
    {
      key: "vendorName",
      title: "Vendor",
      render: (data) => data?.vendor?.vendorLegalName || "-",
    },
    {
      key: "quantityOfWasteManaged",
      title: "Quantity of Waste Managed",
    },
    // { key: "remark", title: "Remarks" },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Waste Type",
      type: "option",
      key: "origin",
      value: filter.wasteType ? filter.wasteType : [],
    },
    {
      title: "Waste Management Method",
      type: "option",
      key: "destination",
      value: filter.wasteManagementMethod ? filter.wasteManagementMethod : [],
    },
  ];

  const toggleData = [];
  const fetchDataCallback = async () => {
    await fetchData();
  };

  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData: toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
        }}
        heading={"Waste Generated in Operations"}
      />
      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
        setsnackOpen={setsnackOpen}
        fetchDataCallback={fetchDataCallback}
        apiUrl={approvalUrl}
        // viewcolumnWidth={viewcolumnWidth}
        viewheaders={viewheaders}
        viewPage={WasteGeneratedView}
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default WasteGeneratedDocuments;
